<template>
    <div v-if="error && error.length > 0" class="text-left red-text">
        {{ error }}
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
const AppErrorField = defineComponent({
    props: {
        error: {
            type: String,
            default: '',
        },
    },
});
export default AppErrorField;
</script>
